import { render, staticRenderFns } from "./NftCollectionModal.vue?vue&type=template&id=3b51f7de"
import script from "./NftCollectionModal.vue?vue&type=script&lang=ts"
export * from "./NftCollectionModal.vue?vue&type=script&lang=ts"
import style0 from "./NftCollectionModal.vue?vue&type=style&index=0&id=3b51f7de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports